import Search from "../search";
import { useState, useEffect } from "react";

export default function Weather() {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState(null);

  async function fetchWeatherData(param) {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${param}&lang=en&appid=${process.env.REACT_APP_API_KEY}`
      ); // ` alt+96

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      if (data) {
        setWeather(data);
        setLoading(false);
        // console.log(data);
      }
    } catch (e) {
      setError(e.message);
      setLoading(false);
      //console.log(e);
    }
  }

  async function handleSearch() {
    fetchWeatherData(search);
  }

  /*
  function getCurrentDate() {
    return new Date().toLocaleString("en-us", {
      //weekday: "long",
      month: "long",
      // day: "numeric",
      year: "numeric",
      // hour: "numeric",
      //minute: "numeric",
      //second: "numeric",
      //hour12: true, // Use 12-hour format
    });
  }*/

  //console.log(getCurrentDate);

  useEffect(() => {
    fetchWeatherData("Caracas");
  }, []);

  // console.log(weatherData)
  //console.log(loading);
  /*
  function getCurrentUTCDate() {
    return new Date().toUTCString();
  }
*/
  //console.log(getCurrentUTCDate());

  function calculateTimeFromUTC(timezoneOffsetInSeconds) {
    // Get the current UTC time
    const utcDate = new Date();

    // Convert the timezone offset from seconds to milliseconds
    const timezoneOffsetInMilliseconds = timezoneOffsetInSeconds * 1000;

    // Calculate the time by adding the timezone offset
    const calculatedTime = new Date(
      utcDate.getTime() + timezoneOffsetInMilliseconds
    );

    // Return the calculated time in UTC string format
    return calculatedTime.toUTCString();
  }

  // Example usage
  //console.log(calculateTimeFromUTC(weather?.timezone)); // Caracas timezone offset

  return (
    <div>
      <Search
        search={search}
        setSearch={setSearch}
        handleSearch={handleSearch}
      />
      {loading ? (
        <div className="loading">Loading...</div>
      ) : error ? (
        <div className="error">
          The city you just searched is not in our database, please try again
          with a different city
        </div> // Display error message
      ) : (
        <div>
          <div className="city-name">
            <h2>
              {weather?.name}, {weather?.sys.country}
            </h2>
          </div>
          <div className="date">
            <span>
              {calculateTimeFromUTC(weather?.timezone)}{" "}
              {/* {getCurrentDate()} */}
            </span>
          </div>

          <p className="description">{weather?.weather[0].main}</p>

          <div className="temp">
            {/* Temperature: {weather?.main.temp} K */}
            {(1.8 * (weather?.main.temp - 273.15) + 32).toFixed(2)} °F |
            {/*alt+124*/} {(weather?.main.temp - 273.15).toFixed(2)} °C
          </div>

          <div className="weather-info">
            <div className="column">
              <div>
                <p>Feels like</p>
                <p>
                  {(1.8 * (weather?.main.feels_like - 273.15) + 32).toFixed(2)}{" "}
                  °F |{/*alt+124*/}{" "}
                  {(weather?.main.feels_like - 273.15).toFixed(2)} °C
                </p>
              </div>
            </div>
            <div className="column">
              <div>
                <p>Temperature Range</p>
                <p>
                  {(1.8 * (weather?.main.temp_min - 273.15) + 32).toFixed(2)} °F
                  |{/*alt+124*/} {(weather?.main.temp_min - 273.15).toFixed(2)}{" "}
                  °C,
                </p>
                <p>
                  {" "}
                  {(1.8 * (weather?.main.temp_max - 273.15) + 32).toFixed(2)} °F
                  |{/*alt+124*/} {(weather?.main.temp_max - 273.15).toFixed(2)}{" "}
                  °C
                </p>
              </div>
            </div>
          </div>

          <div className="weather-info">
            <div className="column">
              <div>
                <p>Wind Speed</p>
                <p className="wind">{weather?.wind.speed} m/s</p>
              </div>
            </div>
            <div className="column">
              <div>
                <p>Humidity</p>
                <p>{weather?.main.humidity}%</p>
              </div>
            </div>

            {/*
            <div className="column">
              <div>
                <p>Local Time and Date</p>
                <p>{calculateTimeFromUTC(weather?.timezone)}</p>
              </div>
            </div>*/}
          </div>
        </div>
      )}
    </div>
  );
}
